// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4871":"3df6e6fd061c1f7c","6291":"8b77e2da2a18e6f6"}[chunkId] + ".js";
};